var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Picker',{attrs:{"set":"facebook","data":_vm.emojiIndex,"emoji-size":24,"per-line":8,"native":false,"emojis-to-show-filter":_vm.emojisToShowFilter,"infinite-scroll":true},on:{"select":_vm.addEmoji}})}
var staticRenderFns = []

export { render, staticRenderFns }